
import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from '@vue/composition-api';
import { updateMemo } from '@/v2/discovery/apis';

const IMAGE_TYPE = ['png', 'jpg', 'jpeg'];
const FILE_TYPE = ['pptx', 'xlsx', 'vnd', 'pdf'];

export default defineComponent({
  name: 'ModifyComment',
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => {},
    },
    checkId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  emit: ['selectFiles', 'onChangeComment', 'onChangePrivate', 'onSubmitComment', 'getAllComments'],
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    const vm = instance?.proxy;
    const t = vm?.$t ? vm.$t.bind(vm) : (msg: string) => msg;

    const modifyComments = reactive({
      ...JSON.parse(JSON.stringify(props.comment)),
      deleteFileIds: [],
      multipartFiles: [],
    });

    const images = ref<any[]>([]);
    const file = ref<any[]>([]);

    onMounted(() => {
      console.log('props.comment.files', props.comment.files);

      if (props.comment.files && props.comment.files.length > 0) {
        props.comment.files.forEach(item => {
          if (IMAGE_TYPE.includes(item.contentType.split('/')[1])) {
            images.value.push(item);
          } else {
            file.value.push(item);
          }
        });
      }
    });

    const onChangeComment = (e: any) => {
      modifyComments.content = e.target.value;
    };

    const onChangePrivate = (e: any) => {
      const PUBLIC = 0;
      const PRIVATE = 1;

      modifyComments.isPrivate = e.target.checked ? PRIVATE : PUBLIC;
    };

    const handleFileUpload = (event: any) => {
      const selectedFiles = Array.from(event.target.files);

      selectedFiles.forEach(item => {
        if (item.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent<FileReader>) => {
            const url = e.target?.result as string;
            modifyComments.files.push(item);
            images.value.push({ file: item, url });
          };
          reader.readAsDataURL(item);
        } else {
          modifyComments.files.push(item);
          file.value.push(item);
        }
      });

      event.target.value = ''; // 초기화
    };

    const onSelectFiles = (files: any | any[], type?: string) => {
      let filesArray: any[];

      if (Array.isArray(files)) {
        filesArray = files;
      } else if (typeof files === 'object' && files !== null && 'file' in files) {
        filesArray = [files['file']];
      } else {
        filesArray = [files];
      }

      if (filesArray && filesArray.length > 0) {
        filesArray.forEach(item => {
          if (!type) {
            const index = modifyComments.files.findIndex((f: any) => {
              return (
                f.name === item.name &&
                f.size === item.size &&
                f.lastModified === item.lastModified &&
                (f.type === item.type || f.contentType === item.contentType)
              );
            });

            if (index !== -1) {
              modifyComments.files.splice(index, 1);
              return;
            }

            modifyComments.files.push(file);
            return;
          }

          if (type === 'file') {
            const fileIdx = file.value.findIndex((f: any) => {
              console.log(f.id, item.id);
              return f.id === item.id;
            });

            if (fileIdx !== -1) {
              file.value.splice(fileIdx, 1);
              return;
            }

            file.value.push(file);
            return;
          }

          if (type === 'image') {
            const imageIdx = images.value.findIndex((f: any) => {
              console.log(f.id, item.id);
              return f.id === item.id;
            });

            if (imageIdx !== -1) {
              images.value.splice(imageIdx, 1);
              return;
            }

            images.value.push(file);
          }
        });
      }
    };

    const removeFile = (index: number) => {
      const displayFile = file.value[index];

      const fileIdx = modifyComments.files.findIndex(file => {
        return file.id === displayFile.id;
      });

      const paramsFile = modifyComments.files[fileIdx];

      if (paramsFile) {
        onSelectFiles(paramsFile);

        if (paramsFile.id) {
          modifyComments.deleteFileIds.push(paramsFile.id);
        }
      }

      if (displayFile) {
        onSelectFiles(displayFile, 'file');
      }
    };

    const removeImage = (index: number) => {
      const imageFile = images.value[index];

      const fileIdx = modifyComments.files.findIndex(file => {
        return file.id === imageFile.id;
      });

      const paramsFile = modifyComments.files[fileIdx];

      if (paramsFile) {
        onSelectFiles(paramsFile);

        if (paramsFile.id) {
          modifyComments.deleteFileIds.push(paramsFile.id);
        }
      }

      if (imageFile) {
        onSelectFiles(imageFile, 'image');
      }
    };

    const formatSize = size => {
      const mb = size / (1024 * 1024);
      return `${mb.toFixed(2)}MB`;
    };

    const fileInputRef = ref<HTMLInputElement | null>(null);
    const imageInputRef = ref<HTMLInputElement | null>(null);

    const triggerFileInput = (type: number) => {
      const IMAGE = 0;
      const FILE = 1;

      if (imageInputRef.value && type === IMAGE) {
        imageInputRef.value.click();
      }

      if (fileInputRef.value && type === FILE) {
        fileInputRef.value.click();
      }
    };

    const checkIncludeFiles = (files: any[]) => {
      if (files && files.length > 0) {
        return files.some(file => FILE_TYPE.includes(file.contentType.split('/')[1]));
      }

      return false;
    };

    const checkIncludeImages = (images: any[]) => {
      if (images && images.length > 0) {
        return images.some(image => IMAGE_TYPE.includes(image.contentType.split('/')[1]));
      }

      return false;
    };

    const onSubmitComment = async () => {
      const { files: multipartFiles, ...others } = modifyComments;

      await updateMemo({ memo: others, multipartFiles }).then((result: any) => {
        emit('getAllComments', result);
      });
    };

    return {
      ...toRefs(modifyComments),
      t,
      IMAGE_TYPE,
      FILE_TYPE,
      images,
      file,
      fileInputRef,
      imageInputRef,
      onChangeComment,
      onChangePrivate,
      onSubmitComment,
      handleFileUpload,
      removeFile,
      removeImage,
      formatSize,
      triggerFileInput,
      checkIncludeFiles,
      checkIncludeImages,
    };
  },
});
